export default __webpack_public_path__ + "static/media/vision.bd00ed59.png";